import UmsActionTypes from './types';

export const fetchOperatorSubordinatesStart = () => ({
  type: UmsActionTypes.FETCH_OPERATOR_SUBORDINATES_START,
});
export const fetchOperatorSubordinatesSuccess = (data: any) => ({
  type: UmsActionTypes.FETCH_OPERATOR_SUBORDINATES_SUCCESS,
  payload: data,
});
export const fetchOperatorSubordinatesFailure = (errorMessage: any) => ({
  type: UmsActionTypes.FETCH_OPERATOR_SUBORDINATES_FAILURE,
  payload: errorMessage,
});
export const deleteOperatorSubordinateStart = (data: any) => ({
  type: UmsActionTypes.DELETE_OPERATOR_SUBORDINATE_START,
  payload: data,
});
export const deleteOperatorSubordinateSuccess = (successMessage: any) => ({
  type: UmsActionTypes.DELETE_OPERATOR_SUBORDINATE_SUCCESS,
  payload: successMessage,
});
export const deleteOperatorSubordinateFailure = (errorMessage: any) => ({
  type: UmsActionTypes.DELETE_OPERATOR_SUBORDINATE_FAILURE,
  payload: errorMessage,
});
export const fetchAllRolesStart = () => ({
  type: UmsActionTypes.FETCH_ALL_ROLES_START,
});
export const fetchAllRolesSuccess = (data: any) => ({
  type: UmsActionTypes.FETCH_ALL_ROLES_SUCCESS,
  payload: data,
});
export const fetchAllVehiclesStart = () => ({
  type: UmsActionTypes.FETCH_ALL_VEHICLES_START,
});
export const fetchAllVehiclesSuccess = (data: any) => ({
  type: UmsActionTypes.FETCH_ALL_VEHICLES_SUCCESS,
  payload: data,
});
export const fetchPermissionStart = () => ({
  type: UmsActionTypes.FETCH_PERMISSION_START,
});
export const fetchPermissionSuccess = (data: any) => ({
  type: UmsActionTypes.FETCH_PERMISSION_SUCCESS,
  payload: data,
});
export const createRoleStart = (data: any) => ({
  type: UmsActionTypes.CREATE_ROLE_START,
  payload: data,
});
export const createRoleSuccess = (data: any) => ({
  type: UmsActionTypes.CREATE_ROLE_SUCCESS,
  payload: data,
});
export const createRoleFailure = (data: any) => ({
  type: UmsActionTypes.CREATE_ROLE_FAILURE,
  payload: data,
});
export const addRoleStart = (data: any) => ({
  type: UmsActionTypes.ADD_ROLE_START,
  payload: data,
});
export const addRoleSuccess = (data: any) => ({
  type: UmsActionTypes.ADD_ROLE_SUCCESS,
  payload: data,
});
export const addRoleFailure = (data: any) => ({
  type: UmsActionTypes.ADD_ROLE_FAILURE,
  payload: data,
});
export const deleteRoleStart = (data: any) => ({
  type: UmsActionTypes.DELETE_ROLE_START,
  payload: data,
});
export const deleteRoleSuccess = (data: any) => ({
  type: UmsActionTypes.DELETE_ROLE_SUCCESS,
  payload: data,
});
export const deleteRoleFailure = (data: any) => ({
  type: UmsActionTypes.DELETE_ROLE_FAILURE,
  payload: data,
});
export const addUserStart = (data: any) => ({
  type: UmsActionTypes.ADD_USER_START,
  payload: data,
});
export const addUserSuccess = (data: any) => ({
  type: UmsActionTypes.ADD_USER_SUCCESS,
  payload: data,
});

export const removeUserSuccess = () => ({
  type: UmsActionTypes.REMOVE_USER_SUCCESS,
});
